import LegalPage from "./LegalPage";
const Terms = () => <LegalPage docKey="terms" />;
export default Terms;
